import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({
    q: t(`faq.q${n}`),
    a: t(`faq.a${n}`),
  }));

  return (
    <>
      <section id="faq" className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <div className="mx-auto max-w-3xl">
            <div className="text-center">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                {t("faq.title")}
              </h2>
            </div>

            <div className="mt-8 space-y-3">
              {faqs.map((item, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <div
                    key={item.q}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : idx)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span className="w-6 h-6 flex shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                        <i
                          className={`ri-arrow-down-s-line transition-transform ${
                            isOpen ? "rotate-180" : ""
                          }`}
                        ></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <div className="rounded-2xl bg-primary-500 p-8 text-center md:p-14">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              {t("final.title")}
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-base text-background-100">
              {t("final.text")}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 rounded-full bg-background-50 px-8 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                {t("final.ctaPrimary")}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
              <a
                href="#guides"
                className="inline-flex items-center gap-2 rounded-full border border-background-50/50 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
              >
                {t("final.ctaSecondary")}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}